import { useContext } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import {
  // HomeOutlined,
  InfoRounded,
  Logout,
  Assessment,
} from "@mui/icons-material";
// import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
// import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
// import GamepadRoundedIcon from '@mui/icons-material/GamepadRounded';
// import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
// import StoreRoundedIcon from '@mui/icons-material/StoreRounded';
import SupervisedUserCircleRoundedIcon from "@mui/icons-material/SupervisedUserCircleRounded";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import SecurityIcon from '@mui/icons-material/Security';
import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  Paper,
  styled,
} from "@mui/material";
import { NavLink as RouterLink, useNavigate } from "react-router-dom";
import { SidebarContext } from "src/context/SidebarContext";
import UserInfo from "src/components/UserInfo/UserInfo";
import { env } from "src/env";
import pages from "src/router/routes";
import ShowChartIcon from '@mui/icons-material/ShowChart';

const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(1)};

    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
    }
  }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: ${theme.sidebar.menuItemHeadingColor};
      padding: ${theme.spacing(0, 2.5)};
      line-height: 1.4;
    }
`
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {

      .MuiListItem-root {
        padding: 1px 0;

        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(3.2)};

          .MuiBadge-standard {
            background: ${theme.colors.primary.main};
            font-size: ${theme.typography.pxToRem(10)};
            font-weight: bold;
            text-transform: uppercase;
            color: ${theme.palette.primary.contrastText};
          }
        }
    
        .MuiButton-root {
          display: flex;
          color: ${theme.palette.text.primary};
          background-color: transparent;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};

          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(["color"])};

            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }

          .MuiButton-startIcon {
            color: ${theme.sidebar.menuItemIconColor};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
          }
          
          .MuiButton-endIcon {
            color: ${theme.sidebar.menuItemIconColor};
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }

          &.active,
          &:hover {
            background-color: ${theme.sidebar.menuItemBgActive};
            color: ${theme.sidebar.menuItemColorActive};

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.sidebar.menuItemIconColorActive};
            }
          }
        }

        &.Mui-children {
          flex-direction: column;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(7)};
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 1px 0;

            .MuiButton-root {
              padding: ${theme.spacing(0.8, 3)};

              .MuiBadge-root {
                right: ${theme.spacing(3.2)};
              }

              &:before {
                content: ' ';
                background: ${theme.colors.alpha.trueWhite[100]};
                opacity: 0;
                transition: ${theme.transitions.create([
                  "transform",
                  "opacity",
                ])};
                width: 6px;
                height: 6px;
                transform: scale(0);
                transform-origin: center;
                border-radius: 20px;
                margin-right: ${theme.spacing(1.8)};
              }

              &.active,
              &:hover {

                &:before {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
`
);

function SidebarMenu() {
  const { closeSidebar } = useContext(SidebarContext);

  const { logout } = useAuth0();
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      logout({ logoutParams: { returnTo: env.REACT_APP_APP_BASE_URL } });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <MenuWrapper>
        <List component="div">
          <SubMenuWrapper>
            <List component="div">
              {/* <ListItem component='div'>
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to='/home'
                  startIcon={<HomeOutlined color='primary' />}
                >
                  Dashboard (Coming Soon)
                </Button>
              </ListItem> */}
              {/* <ListItem component='div'>
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to='/alerts'
                  startIcon={<CampaignRoundedIcon color='primary' />}
                >
                  Alerts (Coming Soon)
                </Button>
              </ListItem> */}
              {/* <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to="/alerts-dashboard"
                  startIcon={<NotificationsActiveIcon color="primary" />}
                >
                  Dashboard
                </Button>
              </ListItem> */}
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to={pages.playersDashboard.path}
                  startIcon={
                    <SupervisedUserCircleRoundedIcon color="primary" />
                  }
                >
                  Players
                </Button>
              </ListItem>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to={pages.rulesDashboard.path}
                  startIcon={<CircleNotificationsIcon color="primary" />}
                >
                  Alert Rules
                </Button>
              </ListItem>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to={pages.openTrades.path}
                  startIcon={<ShowChartIcon color="primary" />}
                >
                  Open Trades
                </Button>
              </ListItem>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to={pages.riskSettings.path}
                  startIcon={<SecurityIcon color="primary" />}
                >
                  Risk Settings
                </Button>
              </ListItem>
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to={pages.reports.path}
                  startIcon={<Assessment color="primary" />}
                >
                  Reports
                </Button>
              </ListItem>
              {/* <ListItem component='div'>
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to='/rules-dashboard'
                  startIcon={<PolylineIcon color='primary' />}
                >
                  Rules
                </Button>
              </ListItem> */}
              {/* <ListItem component='div'>
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to='/game'
                  startIcon={<GamepadRoundedIcon color='primary' />}
                >
                  Game (Coming Soon)
                </Button>
              </ListItem> */}
              {/* <ListItem component='div'>
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to='/account'
                  startIcon={<AccountBalanceRoundedIcon color='primary' />}
                >
                  Account (Coming Soon)
                </Button>
              </ListItem> */}
              {/* <ListItem component='div'>
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to='/market'
                  startIcon={<StoreRoundedIcon color='primary' />}
                >
                  Market (Coming Soon)
                </Button>
              </ListItem> */}
              {/* <ListItem component='div'>
                <Button
                  disableRipple
                  component={RouterLink}
                  onClick={closeSidebar}
                  to='/system-dashboard'
                  startIcon={<SettingsSuggestIcon color='primary' />}
                >
                  System (Coming Soon)
                </Button>
              </ListItem> */}
            </List>
          </SubMenuWrapper>
          <SubMenuWrapper
            sx={{
              position: "fixed",
              bottom: 100,
              textAlign: "center",
            }}
          >
            <List component="div">
              <ListItem component="div">
                <Paper>
                  <Box textAlign="center" sx={{ mt: 3 }}>
                    <UserInfo />
                  </Box>
                </Paper>
              </ListItem>
              {/* <ListItem component='div'>
                <Box textAlign='center'>
                  <Button
                    disableRipple
                    onClick={() => alert('Coming Soon')}
                    startIcon={<HelpOutlineOutlined color='primary' />}
                  >
                    Help
                  </Button>
                </Box>
              </ListItem> */}

              <ListItem component="div">
                <Box textAlign="center">
                  <Button
                    disableRipple
                    onClick={handleLogout}
                    startIcon={<Logout color="primary" />}
                  >
                    Sign Out
                  </Button>
                </Box>
              </ListItem>
            </List>
          </SubMenuWrapper>
        </List>
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            // width: '100%'
          }}
        >
          <IconButton onClick={() => navigate("/health")}>
            <InfoRounded fontSize="small" />
          </IconButton>
          v1.0.7
        </Box>
      </MenuWrapper>
    </>
  );
}

export default SidebarMenu;
